import React, { useState } from 'react';
import axios from 'axios';
import LegalModal from './LegalModal';
import logoAnica from '../assets/logo-anica.png';

const API_URL = '/api';

function Login({ onLogin, initialError = '' }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(initialError);
  const [loading, setLoading] = useState(false);
  const [legalModalOpen, setLegalModalOpen] = useState(false);
  const [legalTab, setLegalTab] = useState('privacy');

  React.useEffect(() => {
    if (initialError) {
      setError(initialError);
    }
  }, [initialError]);

  const openLegal = (tab) => {
    setLegalTab(tab);
    setLegalModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email: email.trim(),
        password: password.trim(),
      });

      const { access_token, user } = response.data;
      if (onLogin) {
        onLogin({ token: access_token, user });
      }
    } catch (err) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else if (!err.response) {
        setError(`Cannot connect to ${API_URL}/auth/login: Network error`);
      } else {
        setError('Login failed. Please check your email and password.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src={logoAnica} alt="The Coach Anica" className="login-logo-img" />
          <div className="login-brand-tag">TRAINING PLATFORM</div>
          <p className="login-subtitle">Sign in</p>
        </div>

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              id="email"
              type="email"
              maxLength={120}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <input
              id="password"
              type="password"
              maxLength={128}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="button button-primary login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <p className="login-notice-text">
            By signing in, you acknowledge that you have read and agree to our{' '}
            <button type="button" className="login-inline-link" onClick={() => openLegal('terms')}>
              Terms of Service
            </button>{' '}
            and{' '}
            <button type="button" className="login-inline-link" onClick={() => openLegal('privacy')}>
              Privacy Policy
            </button>.
          </p>
        </form>
      </div>

      <LegalModal
        isOpen={legalModalOpen}
        initialTab={legalTab}
        onClose={() => setLegalModalOpen(false)}
      />
    </div>
  );
}

export default Login;
